import React from "react";

const InnovationSVG = () => (
  <svg
    width="100%"
    height="auto"
    viewBox="0 0 171 126"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
  >
    <title>Artboard</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Artboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Innovation" transform="translate(33.000000, 9.000000)">
        <path
          d="M57.52,115.041 C89.287,115.041 115.04,89.288 115.04,57.521 C115.04,25.754 89.287,0.001 57.52,0.001 C25.753,0.001 0,25.754 0,57.521 C0,89.288 25.753,115.041 57.52,115.041"
          id="Fill-1"
          fill="#51595C"
        ></path>
        <path
          d="M43.6396,19.1054 C29.8786,25.6674 22.7666,40.7874 25.5736,55.2404 L75.7226,21.5474 C66.4376,15.2284 54.2816,14.0294 43.6396,19.1054"
          id="Scalp"
          fill="#0F070C"
        ></path>
        <path
          d="M81,51 C79.6666667,43.6666667 76.3333333,39.6666667 71,39 C63,38 53,40 50,46 C47,52 50,63 60,58 C70,53 82,34 73,30 C64,26 47,34 46,42 C45,50 62,62 70,58 C78,54 67,21 55,28 C43,35 27,50 37,54 C47,58 55,52 58,47 C61,42 65,42 61,34 C57,26 45,31 41,35 C37,39 40,47 43,47 C46,47 83,54 80,40 C77,26 71,17 56,35 C41,53 62,51 65,46 C68,41 71,26 64,23 C57,20 43,31 43,41 C43,51 85,44 83,38 C81,32 61,19 47,27 C33,35 69,62 77,56 C85,50 81,25 59,36 C37,47 47,67 59,64 C71,61 72,27 51,37 C30,47 36,60 45,65"
          id="Squiggle1"
          stroke="#FFFFFF"
          className="squiggle"
        ></path>
        <path
          d="M76.1442456,55.5023917 C74.8109122,48.1690584 71.4775789,44.1690584 66.1442456,43.5023917 C58.1442456,42.5023917 48.1442456,44.5023917 45.1442456,50.5023917 C42.1442456,56.5023917 45.1442456,67.5023917 55.1442456,62.5023917 C65.1442456,57.5023917 77.1442456,38.5023917 68.1442456,34.5023917 C59.1442456,30.5023917 42.1442456,38.5023917 41.1442456,46.5023917 C40.1442456,54.5023917 57.1442456,66.5023917 65.1442456,62.5023917 C73.1442456,58.5023917 62.1442456,25.5023917 50.1442456,32.5023917 C38.1442456,39.5023917 22.1442456,54.5023917 32.1442456,58.5023917 C42.1442456,62.5023917 50.1442456,56.5023917 53.1442456,51.5023917 C56.1442456,46.5023917 60.1442456,46.5023917 56.1442456,38.5023917 C52.1442456,30.5023917 40.1442456,35.5023917 36.1442456,39.5023917 C32.1442456,43.5023917 35.1442456,51.5023917 38.1442456,51.5023917 C41.1442456,51.5023917 78.1442456,58.5023917 75.1442456,44.5023917 C72.1442456,30.5023917 66.1442456,21.5023917 51.1442456,39.5023917 C36.1442456,57.5023917 57.1442456,55.5023917 60.1442456,50.5023917 C63.1442456,45.5023917 66.1442456,30.5023917 59.1442456,27.5023917 C52.1442456,24.5023917 38.1442456,35.5023917 38.1442456,45.5023917 C38.1442456,55.5023917 80.1442456,48.5023917 78.1442456,42.5023917 C76.1442456,36.5023917 56.1442456,23.5023917 42.1442456,31.5023917 C28.1442456,39.5023917 64.1442456,66.5023917 72.1442456,60.5023917 C80.1442456,54.5023917 76.1442456,29.5023917 54.1442456,40.5023917 C32.1442456,51.5023917 42.1442456,71.5023917 54.1442456,68.5023917 C66.1442456,65.5023917 67.1442456,31.5023917 46.1442456,41.5023917 C25.1442456,51.5023917 55.7702181,64.3268213 64.7702181,69.3268213"
          id="Squiggle2"
          stroke="#FFFFFF"
          transform="translate(53.606736, 48.163411) rotate(87.000000) translate(-53.606736, -48.163411) "
          className="squiggle"
        ></path>
        <path
          d="M89.2202,58.206 C88.5092,54.222 87.1082,50.515 85.1552,47.201 L25.5832,56.038 C24.9412,58.614 24.6002,61.31 24.6002,64.083 C24.6002,64.258 24.6022,64.437 24.6062,64.62 C24.6192,65.443 24.6612,66.265 24.7322,67.062 C24.8802,69.031 25.1362,71.316 25.4072,73.735 C25.4652,74.257 25.5242,74.788 25.5842,75.324 C26.0642,79.672 26.5432,84.421 26.5432,88.744 L26.5432,116.041 L64.7592,116.041 L64.7592,108.7 C64.7592,105.423 67.3952,102.756 70.6362,102.756 L81.3072,102.756 C84.0772,102.756 86.3312,100.477 86.3312,97.675 L86.3312,94.838 L86.3312,81.657 L92.1732,79.734 L89.5792,60.821 C89.4932,59.943 89.3732,59.063 89.2202,58.206"
          id="Head"
          fill="#0F070C"
        ></path>
      </g>
    </g>
  </svg>
);

export default InnovationSVG;
